import React from 'react'
import { TextInput } from 'react-admin'
import { EditGuesser } from 'theme/components'

export const RegionEdit = (props) => (
  <EditGuesser {...props} undoable={false} variant="outlined" redirect="list">
    <TextInput source="name" />
  </EditGuesser>
)
